import { useMemo } from "react";
import { PDFHorizontalTableRow } from "components/PDF/Table/HorizontalTable";
import { BalancoFinanceiroContaBancaria } from "core/features/relatorios/typings";
import { formatMoney } from "infra/helpers/number";

export function useMovimentacaoContasBancariasTableRows() {
  return useMemo(() => {
    return [
      {
        title: "01 - Saldo Anterior",
        renderValue: (original) => formatMoney(original.saldoAnterior),
      },
      {
        title: "02 - Créditos",
        renderValue: (original) => formatMoney(original.creditos),
      },
      {
        title: "03 - Débitos",
        renderValue: (original) => formatMoney(original.debitos),
      },
      {
        title: "04 - Transferência (-)",
        renderValue: (original) => formatMoney(original.transferenciaSaida),
        shouldRender: (original) => !!original.transferenciaSaida,
      },
      {
        title: "04 - Transferência (+)",
        renderValue: (original) => formatMoney(original.transferenciaEntrada),
        shouldRender: (original) => !!original.transferenciaEntrada,
      },
    ] as PDFHorizontalTableRow<BalancoFinanceiroContaBancaria>[];
  }, []);
}
